import { 
    GET_REPORT_LIST, 
    SET_REPORT_LIST, 
    SAVE_LINK, 
    IS_LINK_SAVED, 
    DELETE_LINK, 
    SAVE_CATEGORY,
    GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA,
    SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA
} from "./ReportListType";

const getReportList = () => ({
    type: GET_REPORT_LIST
});

const setReportList = (reportList: any) => ({
    type: SET_REPORT_LIST,
    reportList: reportList
});

const getE1UploadTemplateExcelData = (payload: any) => ({
        type: GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA,
        payload
});

const setE1UploadTemplateExcelData = (payload: any) => ({
    type: SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA,
    payload
});

const saveUpdateLink = (payload: any) => ({
    type: SAVE_LINK,
    payload
});

const isLinkSaved = (flag: any) => ({
    type: IS_LINK_SAVED,
    flag
});

const deleteLink = (reportId: number, savedBy: string) => ({
    type: DELETE_LINK,
    reportId,
    savedBy
});

const saveUpdateCategory = (payload: any) => ({
    type: SAVE_CATEGORY,
    payload
});

export {
    getReportList,
    setReportList,
    saveUpdateLink,
    isLinkSaved,
    deleteLink,
    saveUpdateCategory,
    setE1UploadTemplateExcelData,
    getE1UploadTemplateExcelData
}
